module.exports = __webpack_public_path__ + "static/media/PTP.cd227284.png";